<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dpMr5O/tc-custom/9781630471255.jpg?1718106504045" alt="This image is the cover for the book Beckoning"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beckoning
      </h1>
      <p class="bookDescription body article font2">
        <b>“Encouraging to fellow believers and a revelation to skeptics . . . a fascinating read.” —Jerry B. Jenkins, #1 <i>New York Times</i>–bestselling coauthor of the Left Behind series</b><br/>  <br/><i>I’m often asked to describe what happened during the months I spent researching these issues. They want to know what facts were so persuasive that an atheist attorney would become a believer in God. But I never felt I could respond in a way that told the true story. No short answer seemed sufficient. So now, in the following pages, I’ll describe for the first time the specifics of what jolted me out of my atheism . . .</i><br/>  <br/> Michael felt he was living the American dream. For a number of years he’d been reaping the professional and financial rewards of being a commercial litigation attorney. To him, life was great and getting better all the time.<br/>  <br/> He first gained notoriety around his hometown as a nationally ranked tennis player. But now, years later, he was becoming known for his skills as a lawyer and as the youngest elected official in the area. And then, in his late twenties, Michael unexpectedly discovered something that turned his world and his entire idea of life upside down.<br/>  <br/> In response to a challenge from a friend, Michael agreed to investigate issues relating to science, philosophy, and the Scriptures. Comfortable with his life as an atheist, he began reading with an indifferent attitude. But what started as a casual inquiry soon turned into a time of intense research. This is the story of Michael’s journey in his own words, his thoughts and reactions to the evidence he discovered—and the new life that soon followed.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Minot
      </h2>
      
      <p class="authorDescription body article">As an attorney, Michael Minot felt like he was living the life--money in his pocket, the keys to a new convertible, and a keen desire to socialize. His strong atheistic views shaped who he was as a man and a professional. After a challenge from a friend and many months spent investigating the Scriptures and scientific literature, Michael determined that those views failed against the strength of God’s truth. Michael now has a weekly podcast, blogs, and teaches about the truth that transformed him from an atheist attorney into a believer in God.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?85bbfb2a